<template>
  <div>

    <el-dialog
        title="上传视频"
        :visible.sync="dialog"
        :before-close="noDialog"
        width="30%"
        center>
      <el-form :model="resourceProportion" label-width="150px" ref="ResourceProportionForm">
        <el-form-item label="宽度占比(%)" prop="width"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.width" type="number"></el-input>
        </el-form-item>
        <el-form-item label="高度类型" prop="heightType">
          <el-select v-model="resourceProportion.heightType">
            <el-option
                v-for="item in heightTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="resourceProportion.heightType==='1'" label="与宽度百分比(%)" prop="height"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLeNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.height" type="number"></el-input>
        </el-form-item>
        <el-form-item label="圆角(%)" prop="borderRadius"
                      :rules="[
                          { required: true, message: '不能为空'},
                          { validator: notLtNum0, trigger: 'blur' },
                          ]">
          <el-input v-model="resourceProportion.borderRadius" type="number"></el-input>
        </el-form-item>
        <el-form-item label="视频" prop="src"
                      :rules="[
                        {required: true, message: '请上传视频', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                :before-upload="beforeUpload"
                :on-success="afterUpload"
                accept="video/*"
            >
              <video v-if="resourceProportion.src" :src="resourceProportion.src" class="avatar"></video>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button :disabled="loading" type="primary" icon="el-icon-check"
                     @click="insertResource('ResourceProportionForm')">插入文章</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>


import dialogMixin from "@/mixin/dialogMixin";
import {notLeNum0, notLtNum0} from "@/utils/check";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import {generateUUID} from "@/utils/UUIDUtils";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";

export default {
  name: "DialogUploadVideo",
  mixins: [dialogMixin],
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData: {},
      loading: false,
      resourceProportion: {
        width: 100,
        heightType: '0',
        height: 100,
        borderRadius: 0,
        src: undefined,
      },
      heightTypes: [
        {
          value: '0',
          label: '原比例'
        },
        {
          value: '1',
          label: '与宽度百分比'
        },
      ],
    }
  },
  methods: {
    notLtNum0,
    notLeNum0,
    afterUpload(response, file) {
      //上传的完整的文件地址
      const urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}", file.name);
      let name = urlPath.substring(this.fileBaseUrl.length + 1)
      adminGetFileSignUrl(name).then(res => {
        this.resourceProportion.src = res.data
      })
    },
    async beforeUpload() {
      await getAliyunOssSign("/common/sign").then(response => {
        console.log(response)
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + generateUUID() + '_${filename}';
      });
      return true
    },
    insertResource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const videoNode = document.createElement('video');
          videoNode.controls = true;
          videoNode.src = this.resourceProportion.src;
          videoNode.style.borderRadius = this.resourceProportion.borderRadius + '%';
          videoNode.style.width = this.resourceProportion.width + '%';
          if (this.resourceProportion.heightType === '1'){
            videoNode.style.aspectRatio = 1 / this.resourceProportion.height * 100;
          }
          const divNode = document.createElement('div');
          divNode.appendChild(videoNode);
          this.$emit('insert-node', divNode);
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },

  }
}
</script>
<style lang="scss" scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

</style>